// suggestClassroomForChild.js
import { differenceInYears } from "date-fns";
import { calculateEasterSunday } from "../utils/easterUtils";

export function suggestClassroomForChild(child, classrooms, selectedYear) {
    if (!child || !classrooms || !selectedYear) return undefined;

    const birth = new Date(child.dateBirth);
    const yearStart = new Date(selectedYear.startDate);
    const yearEnd   = new Date(selectedYear.endDate);

    const ageAtStart = differenceInYears(yearStart, birth);

    // Wanneer wordt het kind 4/7?
    const turns4 = new Date(birth); turns4.setFullYear(birth.getFullYear() + 4);
    const turns7 = new Date(birth); turns7.setFullYear(birth.getFullYear() + 7);

    const easter   = calculateEasterSunday(yearStart.getFullYear());
    const turns4InThisYear = turns4 >= yearStart && turns4 <= yearEnd;
    const turns7BeforeEaster = turns7 < easter;

    // 🎯 GRADE (groep X): 7 jaar bij start of 7 vóór Pasen → groep = leeftijd - 5
    if (ageAtStart >= 7 || turns7BeforeEaster) {
        const gradeNumber = (ageAtStart >= 7) ? (ageAtStart - 5) : (6 - 5 + 1);
        // uitleg: bij 6→7 vóór Pasen wil je groep 2 ( = 1 + 1 ), maar safer is:
        const computed = Math.max(1, ageAtStart - 5); // fallback
        const target = Number.isFinite(gradeNumber) ? gradeNumber : computed;

        const gradeClass = classrooms.find(
            c => c.classType === "GRADE" && parseInt(c.className.replace(/\D/g, "")) === target
        );
        if (gradeClass) return gradeClass.className;
    }

    // 🎯 Kleuterklas: 4 t/m 6 bij start, of 3 bij start maar wél 4 binnen dit schooljaar
    if (ageAtStart >= 4 && ageAtStart <= 6 || (ageAtStart < 4 && turns4InThisYear)) {
        const k = classrooms.find(c => c.classType === "KINDERGARTEN");
        if (k) return k.className;
    }

    // 🎯 Te jong (wordt ook géén 4 dit schooljaar)
    if (ageAtStart < 4 && !turns4InThisYear) {
        return "Too young";
    }

    return undefined;
}